<template>
  <!-- 资源库总体建设进度跟踪 -->
  <div class="page" :style="{ filter: this.$store.state.isVague ? 'blur(2px)' : '' }">
    <el-row :gutter="12" class="sameLayer beltLegend">
      <el-col :span="8">
        <div class="grid-content">
          <div class="generalBg_Virtualization"></div>
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span>用户建设进度</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <div class="standards_content echartsHeight">
            <vcolumnarChart
              :refId="'userScheduleChart'"
              :datas="userSchedule.dataList"
              :labelShow="true"
              :transverseData="userSchedule.transverseData"
              :colorList="userSchedule.colorList"
              :legendList="userSchedule.legendList"
              :innerText="'单位：人'"
            ></vcolumnarChart>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div class="generalBg_Virtualization"></div>
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span>建设单位和企业用户建设情况</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <div class="standards_content echartsHeight">
            <vcolumnarChart
              :refId="'userConstructionChart'"
              :labelShow="true"
              :datas="userConstruction.dataList"
              :transverseData="userConstruction.transverseData"
              :colorList="userConstruction.colorList"
              :legendList="userConstruction.legendList"
              :innerText="'单位：人'"
            ></vcolumnarChart>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div class="generalBg_Virtualization"></div>
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span>活跃用户占比情况</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <div class="standards_content echartsHeight">
            <vcolumnarChart
              :refId="'constructionUnitChart'"
              :labelShow="true"
              :datas="constructionUnit.dataList"
              :transverseData="constructionUnit.transverseData"
              :colorList="constructionUnit.colorList"
              :legendList="constructionUnit.legendList"
              :innerText="'单位：%'"
            ></vcolumnarChart>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 第二层 -->
    <el-row :gutter="12" class="sameLayer">
      <el-col :span="8">
        <div class="grid-content">
          <div class="generalBg_Virtualization"></div>
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span>素材资源建设进度</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <div class="standards_content echartsHeight">
            <vcolumnarChart
              :refId="'materialChart'"
              :labelShow="true"
              :datas="material.dataList"
              :transverseData="material.transverseData"
              :colorList="material.colorList"
              :legendList="material.legendList"
              :innerText="'单位：个'"
            ></vcolumnarChart>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div class="generalBg_Virtualization"></div>
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span>原创资源占比</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <div class="standards_content echartsHeight">
            <vcolumnarChart
              :refId="'originalResourcesChart'"
              :labelShow="true"
              :datas="originalResources.dataList"
              :transverseData="originalResources.transverseData"
              :colorList="originalResources.colorList"
              :legendList="originalResources.legendList"
              :innerText="'单位：%'"
            ></vcolumnarChart>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div class="generalBg_Virtualization"></div>
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span>素材资源建设质量</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <div class="standards_content echartsHeight">
            <vcolumnarChart
              :refId="'resourcesChart'"
              :datas="resources.dataList"
              :labelShow="true"
              :transverseData="resources.transverseData"
              :colorList="resources.colorList"
              :legendList="resources.legendList"
              :innerText="'单位：%'"
            ></vcolumnarChart>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 第三层 -->
    <el-row :gutter="12" class="sameLayer">
      <!-- <el-col :span="8">
        <div class="grid-content">
          <div class="generalBg_Virtualization"></div>
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span>资源活跃度</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <div class="standards_content echartsHeight">
            <vcolumnarChart :refId="'activeResourcesChart'" :datas='activeResources.dataList' :transverseData='activeResources.transverseData' :colorList='activeResources.colorList' :legendList='activeResources.legendList' :innerText="'单位：个'"></vcolumnarChart>
          </div>
        </div>
      </el-col> -->
      <el-col :span="8">
        <div class="grid-content">
          <div class="generalBg_Virtualization"></div>
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span>资源活跃占比</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <div class="standards_content echartsHeight">
            <vcolumnarChart
              :refId="'activeLivelyChart'"
              :datas="activeLively.dataList"
              :labelShow="true"
              :transverseData="activeLively.transverseData"
              :colorList="activeLively.colorList"
              :legendList="activeLively.legendList"
              :innerText="'单位：%'"
            ></vcolumnarChart>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div class="generalBg_Virtualization"></div>
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span>课程建设进度</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <div class="standards_content echartsHeight">
            <vcolumnarChart
              :refId="'progressChart'"
              :datas="progress.dataList"
              :labelShow="true"
              :transverseData="progress.transverseData"
              :colorList="progress.colorList"
              :legendList="progress.legendList"
              :innerText="'单位：门'"
            ></vcolumnarChart>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div class="generalBg_Virtualization"></div>
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span>建设单位在校学生用户数</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <div class="standards_content echartsHeight">
            <vcolumnarChart
              :refId="'studentUsersChart'"
              :datas="studentUsers.dataList"
              :labelShow="true"
              :transverseData="studentUsers.transverseData"
              :colorList="studentUsers.colorList"
              :legendList="studentUsers.legendList"
              :innerText="'单位：人'"
            ></vcolumnarChart>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 第四层 -->
    <el-row :gutter="12" class="sameLayer" style="margin-bottom: 0px">
      <el-col :span="8">
        <div class="grid-content">
          <div class="generalBg_Virtualization"></div>
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span>建设单位教师用户数</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <div class="standards_content echartsHeight">
            <vcolumnarChart
              :refId="'teachersAndUsersChart'"
              :datas="teachersAndUsers.dataList"
              :labelShow="true"
              :transverseData="teachersAndUsers.transverseData"
              :colorList="teachersAndUsers.colorList"
              :legendList="teachersAndUsers.legendList"
              :innerText="'单位：人'"
            ></vcolumnarChart>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div class="generalBg_Virtualization"></div>
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span>社会学习者活跃用户数量</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <div class="standards_content echartsHeight">
            <vcolumnarChart
              :refId="'activeUsersChart'"
              :datas="activeUsers.dataList"
              :labelShow="true"
              :transverseData="activeUsers.transverseData"
              :colorList="activeUsers.colorList"
              :legendList="activeUsers.legendList"
              :innerText="'单位：人'"
            ></vcolumnarChart>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div class="generalBg_Virtualization"></div>
          <div class="header">
            <div class="header_Virtualization"></div>
            <div class="header_title">
              <i class="h_icon header-icon"></i>
              <span>使用资源库培训社会人员的单位情况</span>
            </div>
            <i class="threePoints el-icon-more"></i>
          </div>
          <div class="standards_content echartsHeight">
            <vcolumnarChart
              :refId="'socialPersonnelChart'"
              :datas="socialPersonnel.dataList"
              :labelShow="true"
              :transverseData="socialPersonnel.transverseData"
              :colorList="socialPersonnel.colorList"
              :legendList="socialPersonnel.legendList"
              :innerText="'单位：个'"
            ></vcolumnarChart>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-backtop :bottom="80" target=".page" class="backtops"></el-backtop>
  </div>
</template>

<script>
import vcolumnarChart from "@/components/chart/vcolumnarChart.vue"; //引入竖柱状图图表

export default {
  components: {
    vcolumnarChart,
  },
  data() {
    return {
      colorList: [
        "#1BF6F8",
        "#3B86FF",
        "#FA4798",
        "#6FE05F",
        "#E0D35F",
        "#5470C6",
        "#DE7E4B",
        "#DE524B",
      ], //柱状图或折线图的颜色

      // 第一层
      userSchedule: {
        //用户建设进度
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
      },
      userConstruction: {
        //建设单位和企业用户建设情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
      },
      constructionUnit: {
        //活跃用户占比情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
      },

      // 第二层
      material: {
        // 素材资源建设进度
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
      },
      originalResources: {
        //原创资源占比
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
      },
      resources: {
        // 素材资源建设质量
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
      },

      // 第三层
      // activeResources: {  //资源活跃度
      //   dataList: [],
      //   transverseData: [],
      //   colorList: [],
      //   legendList: []
      // },
      // 资源活跃占比
      activeLively: {
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
      },
      progress: {
        //课程建设进度
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
      },
      studentUsers: {
        //建设单位在校学生用户数
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
      },

      // 第四层
      teachersAndUsers: {
        //建设单位教师用户数
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
      },
      activeUsers: {
        //社会学习者活跃用户数量
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
      },
      socialPersonnel: {
        //使用资源库培训社会人员的单位情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
      },
    };
  },
  created() {
    // 第一层
    this.userScheduleDom();
    this.userConstructionDom();
    this.constructionUnitDom();

    // 第二层
    this.materialDom();
    this.originalResourcesDom();
    this.resourcesDom();

    // 第三层
    // this.activeResourcesDom()
    this.activeLivelyDom();
    this.progressDom();
    this.studentUsersDom();

    // 第四层
    this.teachersAndUsersDom();
    this.activeUsersDom();
    this.socialPersonnelDom();
  },
  methods: {
    // 第一层
    // 用户建设进度
    userScheduleDom() {
      this.$axios
        .post(this.$apiurls.resourceLibrary, 1, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var realValue = [];
            var targetValue = [];
            var nameList = [];
            for (let i = 0; i < res.data.length; i++) {
              if (!res.data[i].value) {
                res.data[i].value = {};
                res.data[i].value.realValue = 0;
                res.data[i].value.targetValue = 0;
              } else {
                if (!res.data[i].value.realValue) {
                  res.data[i].value.realValue = 0;
                }
                if (!res.data[i].value.targetValue) {
                  res.data[i].value.targetValue = 0;
                }
              }
              realValue.push(res.data[i].value.realValue);
              targetValue.push(res.data[i].value.targetValue);
              nameList.push(res.data[i].name);
            }
            this.userSchedule.dataList = [realValue, targetValue];
            this.userSchedule.transverseData = nameList;
            this.userSchedule.colorList = this.colorList;
            this.userSchedule.legendList = ["监测平台值", "任务目标值"];
          }
        });
    },
    // 建设单位和企业用户建设情况
    userConstructionDom() {
      this.$axios
        .post(this.$apiurls.resourceLibrary, 2, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var realValue = [];
            var targetValue = [];
            var nameList = [];
            for (let i = 0; i < res.data.length; i++) {
              if (!res.data[i].value) {
                res.data[i].value = {};
                res.data[i].value.realValue = 0;
                res.data[i].value.targetValue = 0;
              } else {
                if (!res.data[i].value.realValue) {
                  res.data[i].value.realValue = 0;
                }
                if (!res.data[i].value.targetValue) {
                  res.data[i].value.targetValue = 0;
                }
              }
              realValue.push(res.data[i].value.realValue);
              targetValue.push(res.data[i].value.targetValue);
              nameList.push(res.data[i].name);
            }
            this.userConstruction.dataList = [realValue, targetValue];
            this.userConstruction.transverseData = nameList;
            this.userConstruction.colorList = this.colorList;
            this.userConstruction.legendList = ["监测平台值", "任务目标值"];
          }
        });
    },
    // 活跃用户占比情况
    constructionUnitDom() {
      this.$axios
        .post(this.$apiurls.resourceLibrary, 3, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var realValue = [];
            var targetValue = [];
            var nameList = [];
            for (let i = 0; i < res.data.length; i++) {
              if (!res.data[i].value) {
                res.data[i].value = {};
                res.data[i].value.realValue = 0;
                res.data[i].value.targetValue = 0;
              } else {
                if (!res.data[i].value.realValue) {
                  res.data[i].value.realValue = 0;
                }
                if (!res.data[i].value.targetValue) {
                  res.data[i].value.targetValue = 0;
                }
              }
              realValue.push(res.data[i].value.realValue);
              targetValue.push(res.data[i].value.targetValue);
              nameList.push(res.data[i].name);
            }
            this.constructionUnit.dataList = [realValue, targetValue];
            this.constructionUnit.transverseData = nameList;
            this.constructionUnit.colorList = this.colorList;
            this.constructionUnit.legendList = ["监测平台值", "任务目标值"];
          }
        });
    },

    // 第二层
    // 素材资源建设进度
    materialDom() {
      this.$axios
        .post(this.$apiurls.resourceLibrary, 4, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var realValue = [];
            var targetValue = [];
            var nameList = [];
            for (let i = 0; i < res.data.length; i++) {
              if (!res.data[i].value) {
                res.data[i].value = {};
                res.data[i].value.realValue = 0;
                res.data[i].value.targetValue = 0;
              } else {
                if (!res.data[i].value.realValue) {
                  res.data[i].value.realValue = 0;
                }
                if (!res.data[i].value.targetValue) {
                  res.data[i].value.targetValue = 0;
                }
              }
              realValue.push(res.data[i].value.realValue);
              targetValue.push(res.data[i].value.targetValue);
              nameList.push(res.data[i].name);
            }
            this.material.dataList = [realValue, targetValue];
            this.material.transverseData = nameList;
            this.material.colorList = this.colorList;
            this.material.legendList = ["监测平台值", "任务目标值"];
          }
        });
    },
    // 原创资源占比
    originalResourcesDom() {
      this.$axios
        .post(this.$apiurls.resourceLibrary, 6, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var realValue = [];
            var targetValue = [];
            var nameList = [];
            for (let i = 0; i < res.data.length; i++) {
              if (!res.data[i].value) {
                res.data[i].value = {};
                res.data[i].value.realValue = 0;
                res.data[i].value.targetValue = 0;
              } else {
                if (!res.data[i].value.realValue) {
                  res.data[i].value.realValue = 0;
                }
                if (!res.data[i].value.targetValue) {
                  res.data[i].value.targetValue = 0;
                }
              }
              realValue.push(res.data[i].value.realValue);
              targetValue.push(res.data[i].value.targetValue);
              nameList.push(res.data[i].name);
            }
            this.originalResources.dataList = [realValue, targetValue];
            this.originalResources.transverseData = nameList;
            this.originalResources.colorList = this.colorList;
            this.originalResources.legendList = ["监测平台值", "任务目标值"];
          }
        });
    },
    // 素材资源建设质量
    resourcesDom() {
      this.$axios
        .post(this.$apiurls.resourceLibrary, 5, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var realValue = [];
            var targetValue = [];
            var nameList = [];
            for (let i = 0; i < res.data.length; i++) {
              if (!res.data[i].value) {
                res.data[i].value = {};
                res.data[i].value.realValue = 0;
                res.data[i].value.targetValue = 0;
              } else {
                if (!res.data[i].value.realValue) {
                  res.data[i].value.realValue = 0;
                }
                if (!res.data[i].value.targetValue) {
                  res.data[i].value.targetValue = 0;
                }
              }
              realValue.push(res.data[i].value.realValue);
              targetValue.push(res.data[i].value.targetValue);
              nameList.push(res.data[i].name);
            }
            this.resources.dataList = [realValue, targetValue];
            this.resources.transverseData = nameList;
            this.resources.colorList = this.colorList;
            this.resources.legendList = ["监测平台值", "任务目标值"];
          }
        });
    },

    // 第三层
    // //资源活跃度
    // activeResourcesDom() {
    //   this.$axios.post(this.$apiurls.resourceLibrary, 7, {
    //     loading: false,
    //   }).then((res) => {
    //     if (res) {
    //       var realValue = []
    //       var targetValue = []
    //       var nameList = []
    //       for (let i = 0; i < res.data.length; i++) {
    //         if (!res.data[i].value) {
    //           res.data[i].value = {}
    //           res.data[i].value.realValue = 0
    //           res.data[i].value.targetValue = 0
    //         } else {
    //           if (!res.data[i].value.realValue) {
    //             res.data[i].value.realValue = 0
    //           }
    //           if (!res.data[i].value.targetValue) {
    //             res.data[i].value.targetValue = 0
    //           }
    //         }
    //         realValue.push(res.data[i].value.realValue)
    //         targetValue.push(res.data[i].value.targetValue)
    //         nameList.push(res.data[i].name)
    //       }
    //       this.activeResources.dataList = [realValue, targetValue]
    //       this.activeResources.transverseData = nameList
    //       this.activeResources.colorList = this.colorList
    //       this.activeResources.legendList = ['监测平台值', '任务目标值']
    //     }
    //   });
    // },
    // 资源活跃占比
    activeLivelyDom() {
      this.$axios
        .post(this.$apiurls.resourceLibrary, 7, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var realValue = [];
            var targetValue = [];
            var nameList = [];
            for (let i = 0; i < res.data.length; i++) {
              if (!res.data[i].value) {
                res.data[i].value = {};
                res.data[i].value.realValue = 0;
                res.data[i].value.targetValue = 0;
              } else {
                if (!res.data[i].value.realValue) {
                  res.data[i].value.realValue = 0;
                }
                if (!res.data[i].value.targetValue) {
                  res.data[i].value.targetValue = 0;
                }
              }
              realValue.push(res.data[i].value.realValue);
              targetValue.push(res.data[i].value.targetValue);
              nameList.push(res.data[i].name);
            }
            this.activeLively.dataList = [realValue, targetValue];
            this.activeLively.transverseData = nameList;
            this.activeLively.colorList = this.colorList;
            this.activeLively.legendList = ["监测平台值", "任务目标值"];
          }
        });
    },
    //课程建设进度
    progressDom() {
      this.$axios
        .post(this.$apiurls.resourceLibrary, 8, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var realValue = [];
            var targetValue = [];
            var nameList = [];
            for (let i = 0; i < res.data.length; i++) {
              if (!res.data[i].value) {
                res.data[i].value = {};
                res.data[i].value.realValue = 0;
                res.data[i].value.targetValue = 0;
              } else {
                if (!res.data[i].value.realValue) {
                  res.data[i].value.realValue = 0;
                }
                if (!res.data[i].value.targetValue) {
                  res.data[i].value.targetValue = 0;
                }
              }
              realValue.push(res.data[i].value.realValue);
              targetValue.push(res.data[i].value.targetValue);
              nameList.push(res.data[i].name);
            }
            this.progress.dataList = [realValue, targetValue];
            this.progress.transverseData = nameList;
            this.progress.colorList = this.colorList;
            this.progress.legendList = ["监测平台值", "任务目标值"];
          }
        });
    },
    // 建设单位在校学生用户数
    studentUsersDom() {
      this.$axios
        .post(this.$apiurls.resourceLibrary, 9, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var realValue = [];
            var targetValue = [];
            var nameList = [];
            for (let i = 0; i < res.data.length; i++) {
              if (!res.data[i].value) {
                res.data[i].value = {};
                res.data[i].value.realValue = 0;
                res.data[i].value.targetValue = 0;
              } else {
                if (!res.data[i].value.realValue) {
                  res.data[i].value.realValue = 0;
                }
                if (!res.data[i].value.targetValue) {
                  res.data[i].value.targetValue = 0;
                }
              }
              realValue.push(res.data[i].value.realValue);
              targetValue.push(res.data[i].value.targetValue);
              nameList.push(res.data[i].name);
            }
            this.studentUsers.dataList = [realValue, targetValue];
            this.studentUsers.transverseData = nameList;
            this.studentUsers.colorList = this.colorList;
            this.studentUsers.legendList = ["监测平台值", "任务目标值"];
          }
        });
    },

    // 第四层
    // 建设单位教师用户数
    teachersAndUsersDom() {
      this.$axios
        .post(this.$apiurls.resourceLibrary, 10, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var realValue = [];
            var targetValue = [];
            var nameList = [];
            for (let i = 0; i < res.data.length; i++) {
              if (!res.data[i].value) {
                res.data[i].value = {};
                res.data[i].value.realValue = 0;
                res.data[i].value.targetValue = 0;
              } else {
                if (!res.data[i].value.realValue) {
                  res.data[i].value.realValue = 0;
                }
                if (!res.data[i].value.targetValue) {
                  res.data[i].value.targetValue = 0;
                }
              }
              realValue.push(res.data[i].value.realValue);
              targetValue.push(res.data[i].value.targetValue);
              nameList.push(res.data[i].name);
            }
            this.teachersAndUsers.dataList = [realValue, targetValue];
            this.teachersAndUsers.transverseData = nameList;
            this.teachersAndUsers.colorList = this.colorList;
            this.teachersAndUsers.legendList = ["监测平台值", "任务目标值"];
          }
        });
    },
    // 社会学习者活跃用户数量
    activeUsersDom() {
      this.$axios
        .post(this.$apiurls.resourceLibrary, 11, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var realValue = [];
            var targetValue = [];
            var nameList = [];
            for (let i = 0; i < res.data.length; i++) {
              if (!res.data[i].value) {
                res.data[i].value = {};
                res.data[i].value.realValue = 0;
                res.data[i].value.targetValue = 0;
              } else {
                if (!res.data[i].value.realValue) {
                  res.data[i].value.realValue = 0;
                }
                if (!res.data[i].value.targetValue) {
                  res.data[i].value.targetValue = 0;
                }
              }
              realValue.push(res.data[i].value.realValue);
              targetValue.push(res.data[i].value.targetValue);
              nameList.push(res.data[i].name);
            }
            this.activeUsers.dataList = [realValue, targetValue];
            this.activeUsers.transverseData = nameList;
            this.activeUsers.colorList = this.colorList;
            this.activeUsers.legendList = ["监测平台值", "任务目标值"];
          }
        });
    },
    // 使用资源库培训社会人员的单位情况
    socialPersonnelDom() {
      this.$axios
        .post(this.$apiurls.resourceLibrary, 12, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var realValue = [];
            var targetValue = [];
            var nameList = [];
            for (let i = 0; i < res.data.length; i++) {
              if (!res.data[i].value) {
                res.data[i].value = {};
                res.data[i].value.realValue = 0;
                res.data[i].value.targetValue = 0;
              } else {
                if (!res.data[i].value.realValue) {
                  res.data[i].value.realValue = 0;
                }
                if (!res.data[i].value.targetValue) {
                  res.data[i].value.targetValue = 0;
                }
              }
              realValue.push(res.data[i].value.realValue);
              targetValue.push(res.data[i].value.targetValue);
              nameList.push(res.data[i].name);
            }
            this.socialPersonnel.dataList = [realValue, targetValue];
            this.socialPersonnel.transverseData = nameList;
            this.socialPersonnel.colorList = this.colorList;
            this.socialPersonnel.legendList = ["监测平台值", "任务目标值"];
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.sameLayer {
  position: relative;
  margin-bottom: 12px;
}

.sameLayer .el-col {
  height: 400px;
}

.sameLayer .echartsHeight {
  width: 100%;
  height: calc(100% - 40px);
}

// 带legend
.beltLegend .el-col {
  height: 420px;
}

.el-row:last-child {
  margin-bottom: 0px;
}
</style>
